import React, { useEffect, useState, Suspense } from 'react';
import { useDispatch } from 'react-redux';
import RiseLoader from 'react-spinners/RiseLoader';
import Favicon from 'react-favicon';
import faviconLibelista from 'assets/img/libe.ico';
import MainRoute from './routes';
// page
import Maintenance from 'pages/maintenance';
//context
import UserContextProvider from 'context/userContext';
import MenuContextProvider from 'context/menuContext';
import { GlobalContextProvider } from 'context/globalContext';
import { loadMetaCompany } from 'slices/company';
import { 
  getCategoryMenuNotPaginated, 
  getMetadataCompany, 
  getSettingCompany 
} from 'api/company';
import setCSSVariables from 'utils/setTheme';
import { themeBase } from 'constants';
//styles
import 'assets/css/styles.scss';

export function Welcome() {
  useEffect(() => {
    document.documentElement.style.setProperty('--primary-color', '#0069d9');
    document.documentElement.style.setProperty('--secondary-color', '#f2a20d');
  }, []);
  return (
    <div className="App">
      <Favicon url={faviconLibelista} />
      <GlobalContextProvider>
        <UserContextProvider>
          <MenuContextProvider>
            <MainRoute />
          </MenuContextProvider>
        </UserContextProvider>
      </GlobalContextProvider>
    </div>
  );
}

function App() {
  const [inMaintenance, setInMaintenance] = useState(false);

  const dispatch = useDispatch();


  useEffect(() => {
    const handleSetting = async () => {
      const { data, status } = await getSettingCompany();
      if (status === 200 && data?.results?.length > 0) {
        setInMaintenance(data.results[0].maintenance_mode);
      }
    };
    handleSetting();
    (async () => {
      try {
        const { data, status } = await getMetadataCompany();
        if (status === 200) {
          const matters = await getCategoryMenuNotPaginated({
            fields: 'id,name,description,genre_ibic',
          });
          if (matters.status === 200) {
            const results = {
              ...data,
              matters: matters.data,
            };
            dispatch(loadMetaCompany(results));
          } else {
            dispatch(loadMetaCompany(data));
          }
          setCSSVariables(data.theme);
        } else {
          setCSSVariables(themeBase);
        }
      } catch (e) {}
    })();
    //eslint-disable-next-line
  }, []);


  return (
    <Suspense
      fallback={
        <div className="spinner-container">
          <RiseLoader color="var(--primary-color)" size={25} />
        </div>
      }
    >
      {inMaintenance ? <Maintenance /> : <Welcome />}
    </Suspense>
  );
}

export default App;
